import React from "react";

const CompanyIntroMain = () => {
  return (
    <div className="comp-intro">
      <div className="company-box intro">
        <div className="company-box-content">
          <h3>Vision</h3>
          <div className="paragraph">
            Marina Pedestal을 중심으로 하는 마리나 항만 관리 솔루션을 Metaverse로 구현하는 Marina Platform 구축
          </div>
          <ul className="majorbusiness-list">
            <li>
              <div className="majorbusiness-list-title">Pedestal 통합</div>
              <div className="majorbusiness-list-content">제조사에 의존적이지 않는 원격 제어 및 AMR 시스템</div>
            </li>
            <li>
              <div className="majorbusiness-list-title">마리나 항만 관리</div>
              <div className="majorbusiness-list-content">계류 선박의 계류장 관리와 각종 센서를 통한 상태 정보를 전송, 관리 하는 시스템</div>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default CompanyIntroMain;
